import { appendTestableElementAttributes, Button, FormRouteLeavingPrompt, StyledFlex } from '@dreryk/react-components';

import { certificatesFormTranslationKeys } from '../../../translations';

import { TlsCertificateUploadField } from './fields/TlsCertificateUploadField';
import { WssCertificateUploadField } from './fields/WssCertificateUploadField';
import {
   useCertificatesFormController,
   useCertificatesFormSubmitHandler,
   useGetP1Certificates,
   useSetP1Certificates,
} from './P1CertificatesForm.hooks';
import { StyledCertificateUploadButton } from './StyledCertificateUploadButton';

type P1CertificatesForm = {
   readonly verifyAccountConfiguration: () => Promise<void>;
};
const P1CertificatesForm = (props: P1CertificatesForm): JSX.Element => {
   const { handleSubmit, register, formState, setError } = useCertificatesFormController();
   const { data: p1Certificates, loading: p1CertificatesLoading } = useGetP1Certificates();
   const { executeAsync: setP1Certificates } = useSetP1Certificates({
      onTlsCertificateInvalidPassword: () =>
         setError('tlsCertificatePassword', {
            message: certificatesFormTranslationKeys.certificateProcessingFault.INVALID_CERTIFICATE_PASSWORD,
         }),
      onTlsCertificateFault: (faultType) =>
         setError('tlsCertificateFile', {
            message: certificatesFormTranslationKeys.certificateProcessingFault[faultType],
         }),
      onWssCertificateInvalidPassword: () =>
         setError('wssCertificatePassword', {
            message: certificatesFormTranslationKeys.certificateProcessingFault.INVALID_CERTIFICATE_PASSWORD,
         }),
      onWssCertificateFault: (faultType) =>
         setError('wssCertificateFile', {
            message: certificatesFormTranslationKeys.certificateProcessingFault[faultType],
         }),
      onSuccess: props.verifyAccountConfiguration,
   });

   const submitP1Certificates = useCertificatesFormSubmitHandler(setP1Certificates);

   return (
      <form noValidate autoComplete='off'>
         <StyledFlex gap={24} {...appendTestableElementAttributes('p1Certificates')}>
            <TlsCertificateUploadField
               register={register}
               p1CertificatesLoading={p1CertificatesLoading}
               tlsCertificateMetadata={p1Certificates?.tlsCertificateMetadata}
            />
            <WssCertificateUploadField
               p1CertificatesLoading={p1CertificatesLoading}
               register={register}
               wssCertificateMetadata={p1Certificates?.wssCertificateMetadata}
            />
         </StyledFlex>
         <StyledCertificateUploadButton>
            <Button
               testId={'saveCertificates'}
               onClick={handleSubmit(submitP1Certificates)}
               label={certificatesFormTranslationKeys.submit}
               blockingOperation
            />
         </StyledCertificateUploadButton>
         <FormRouteLeavingPrompt
            formState={formState}
            title={certificatesFormTranslationKeys.leavingPrompt.title}
            message={certificatesFormTranslationKeys.leavingPrompt.message}
         />
      </form>
   );
};

export { P1CertificatesForm };
